import { createContext } from "react";
import { INotificationContext } from "../interfaces/notifications";

const notificationContext = createContext<INotificationContext>({} as INotificationContext)

export default notificationContext